import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
// import { MdOutlineDeleteOutline } from "react-icons/md";
import { Form, Button, Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import FloatingLabelInput from "../restaurant/PlaceHolder";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import {
  getStoredOrganizationId,
  getStoredUserId,
  setStoredOrganizationId,
} from "./organizationStorage";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./css/school-address.css";
import "./css/dashboard.css";


function OrganizationAddress() {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [search, setSearch] = useState("");
  const [organizationId, setorganizationId] = useState(null);
  const [organizationStatus, setOrganizationStatus] = useState("");
  const [address, setAddress] = useState({
    organizationId: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    createdById: "",
    updatedById: "",
    longitude: "",
    latitude: "",
  });
  const navigate = useNavigate();
  const getAuthHeaders = () => {
    const token = localStorage.getItem("Token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    const loadOrganizationAddresses = async () => {
      try {
        const token = localStorage.getItem("Token");
        let orgId = getStoredOrganizationId();
        const userId = getStoredUserId();

        if (!orgId && userId) {
          const linkResponse = await axiosOrganizationInstance.get(
            `/organization/user/${userId}/organization`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          orgId = String(linkResponse.data.organizationId);
          setStoredOrganizationId(orgId);
        }

        if (!orgId) {
          setorganizationId(null);
          setAddresses([]);
          return;
        }

        setorganizationId(orgId);
        await fetchAddresses(orgId);
        await fetchOrganizationStatus(orgId);
      } catch (error) {
        console.error("Error loading organization addresses:", error);
        setAddresses([]);
      }
    };

    loadOrganizationAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrganizationStatus = async (orgId) => {
    try {
      const token = localStorage.getItem("Token");
      const response = await axiosOrganizationInstance.get(`/organization/${orgId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data && response.data.status) {
        setOrganizationStatus(response.data.status);
      }
    } catch (error) {
      console.error("Error fetching organization status:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("Token");
    console.log("token", token);
    setAuthToken(token);

    if (authToken === false) {
      navigate("/organization/signin"); // Redirect if no token is found
    }
  }, [authToken]); // Add `navigate` to dependencies to avoid stale closure issues

  const fetchAddresses = async (orgId) => {
    const resolvedOrgId = orgId || organizationId;
    if (!resolvedOrgId) {
      return;
    }

    try {
      const token = localStorage.getItem("Token");
      setAuthToken(token);
      const response = await axiosOrganizationInstance.get(
        `/organization/${resolvedOrgId}/addresses`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAddresses(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      if (error.response?.status === 704) {
        setAddresses([]);
        return;
      }
      console.error("Error fetching addresses:", error);
      setAddresses([]);
    }
  };

  const handleAddressChange = (field, value) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value, // Update the specific field
    }));
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    // console.log(address)
    if (!address.postalCode) {
      alert("Please Enter the correct postal code");
      return;
    }
    if (!address.longitude || !address.latitude) {
      alert("Invalid address please check");
      return;
    }
    try {
      let response;
      if (isEditing && selectedAddress) {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.put(
          `/organization/addresses/${selectedAddress.addressId}`,
          address,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
        const updatedAddress = response.data;
        setAddresses((prevAddresses) =>
          prevAddresses.map((addr) =>
            addr.addressId === selectedAddress.addressId ? updatedAddress : addr
          )
        );
        alert("Address updated successfully!");
      } else {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.post(
          `/organization_address/${organizationId}}`,
          address,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
        const newAddress = response.data;
        setAddresses((prevAddresses) => [...prevAddresses, newAddress]);
        alert("Address added successfully!");
      }

      fetchAddresses(organizationId);
      resetForm();
    } catch (error) {
      console.error("Error submitting address:", error);
      alert(
        `Error submitting address: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const handleSelectAddress = (addressId) => {
    const addressToEdit = addresses.find(
      (addr) => addr.addressId === addressId
    );
    if (addressToEdit) {
      setAddress(addressToEdit);
      setSelectedAddress(addressToEdit);
      setIsEditing(true);
      setIsFormVisible(true);
    }
  };

  // const handleDeleteAddress = async (addressId) => {
  //   if (window.confirm("Are you sure you want to delete this address?")) {
  //     try {
  //       const token = localStorage.getItem("Token");
  //       await axiosOrganizationInstance.delete(`/organization/address/${addressId}`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
  //         },
  //       });
  //       setAddresses((prevAddresses) =>
  //         prevAddresses.filter((addr) => addr.addressId !== addressId)
  //       );
  //       alert("Address deleted successfully!");
  //     } catch (error) {
  //       console.error("Error deleting address:", error);
  //       alert("Error deleting address. Please check the console for details.");
  //     }
  //   }
  // };

  const resetForm = () => {
    setAddress({
      organizationId: organizationId,
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      createdById: organizationId,
      updatedById: "",
      longitude: "",
      latitude: "",
    });
    setIsEditing(false);
    setSelectedAddress(null);
    setIsFormVisible(false);
  };

  // Handle Address Search
  const handleAddressSearch = async (e) => {
    //   const adrln1 =  e.target.value;
    setSearch(e.target.value);
    if (e.target.value.length > 2) {
      try {
        const response = await axiosOrganizationInstance.get("/address/suggest", {
          headers: getAuthHeaders(),
          params: {
            address: e.target.value,
          },
        });
        setAddressSuggestions(response.data.suggestions || []);
      } catch (error) {
        console.error(
          "Error fetching address suggestions:",
          error.response ? error.response.data : error.message
        );
      }
    } else {
      setAddressSuggestions([]);
    }
  };
  //Address selection

  const handleAddressSelect = async (placeId) => {
    try {
      // Fetch details for the selected address (using Google API or backend service)
      const response = await axiosOrganizationInstance.get("/address/suggest/details", {
        headers: getAuthHeaders(),
        params: { placeId },
      });

      const placeDetails = response.data;

      if (!placeDetails) {
        alert("Address details not found");
        return;
      }

      // Automatically fill in the form fields with the fetched address details
      const adrsline1 = placeDetails.addressLine1 || "";
      const adrsline2 = placeDetails.addressLine2 || "";
      const adrspostal = placeDetails.postalCode || "";
      const adrscity = placeDetails.city || "";
      const adrsstate = placeDetails.state || "";
      const adrsCountry = placeDetails.country || "";
      const adrslat = placeDetails.latitude ?? placeDetails.lat ?? "";
      const adrslong = placeDetails.longitude ?? placeDetails.lon ?? "";

      const updatedAddress = {
        addressLine1: adrsline1 || address.addressLine1,
        addressLine2: adrsline2 || address.addressLine2,

        city: adrscity || address.city,
        state: adrsstate || address.state,
        postalCode: adrspostal || address.postalCode,
        country: adrsCountry || address.country,
        latitude: adrslat !== "" ? adrslat : address.latitude,
        longitude: adrslong !== "" ? adrslong : address.longitude,
        organizationId: organizationId,
        createdById: organizationId,
      };

     
      setAddress((prev)=>({...prev, ...updatedAddress}));
      setSelectedAddress((prev)=>({...prev, ...updatedAddress}));
      console.log("Updated organizationDetails:", updatedAddress); // Debugging
     
      setAddressSuggestions([]); // Clear suggestions after selection
      // setSearch("");
    } catch (error) {
      console.error(
        "Error fetching place details:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div className="mt-5" style={{ marginLeft: '30px', marginRight: '30px' }}>
      
      <Row>
        <Col lg={12} className="mb-1">
          <div className="ag-theme-quartz organization-data-grid">
            <AgGridReact
              columnDefs={[
                {
                  headerName: "Address Line 1",
                  field: "addressLine1",
                  suppressMovable: true,
                  width: "216",
                },
                {
                  headerName: "City",
                  field: "city",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "State",
                  field: "state",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Postal Code",
                  field: "postalCode",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Country",
                  field: "country",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Actions",
                  width: "150",
                  cellRenderer: (params) => {
                    return (
                      isEditing === false && (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ marginTop: "12px" }}
                        >
                          <CiEdit
                            onClick={() =>
                              organizationStatus !== "INACTIVE" && handleSelectAddress(params.data.addressId)
                            }
                            style={{
                              fontSize: "24px",
                              color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                              cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                              opacity: organizationStatus === "INACTIVE" ? 0.5 : 1,
                            }}
                          />

                          {/* <MdOutlineDeleteOutline
                            style={{
                              marginLeft: "20px",
                              color: "#FF3B30",
                              cursor: "pointer",
                              fontSize: "24px",
                            }}
                            onClick={() =>
                              handleDeleteAddress(params.data.addressId)
                            }
                          /> */}
                        </div>
                      )
                    );
                  },
                  suppressMovable: true,
                },
              ]}
              rowData={addresses}
              defaultColDef={{ flex: 1, minWidth: 110 }}
              pagination={false}
              paginationPageSize={10}
              domLayout="autoHeight"
            />
          </div>
        </Col>

        {isFormVisible && (
          <Col lg={12} className="mb-4 organization-form-section">
            <div className="card shadow-box" style={{ border: "none" }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="text-center">
                    {isEditing ? "Edit Address" : "Add New Address"}
                  </h5>
                </div>
                <hr />
                <Form onSubmit={handleAddressSubmit} className="address-form" style={{border:'none'}} noValidate>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col
                      md={6}
                      lg={12}
                      className="colum"
                      // style={{ marginBottom: "10px" }}
                    >
                       <Form.Group className="mb-3">
                       <div style={{ display: "flex", alignItems: "flex-start" }}>
              <Form.Label
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#323E4F",
                }}
              ></Form.Label>
              <FloatingLabelInput
                type="text"
                name="search"
                value={search} // Fallback to an empty string if undefined
                onChange={handleAddressSearch}
                label="Search Address" // Correct label for Address Line 2
                isRequired={false} // Make it a required field
                required={false}
                size="sm" // Adjust input size
                disabled={organizationStatus === "INACTIVE"}
              />

              {addressSuggestions.length > 0 && (
                <ul
                  className="address-suggestions-dropdown"
                  style={{ marginTop: "50px" }}
                >
                  {addressSuggestions.map((suggestion) => (
                    <li
                      key={suggestion.place_id}
                      onClick={() => organizationStatus !== "INACTIVE" && handleAddressSelect(suggestion.place_id)}
                      style={{
                        cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                        opacity: organizationStatus === "INACTIVE" ? 0.5 : 1,
                      }}
                    >
                      {suggestion.description}
                    </li>
                  ))}
                </ul>
              )}
            </div>
                       </Form.Group>
                    </Col>
                  </Row>
         
                  <Row>
                   
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Address Line 1
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="addressLine1"
                          value={address.addressLine1}
                          onChange={(e) =>
                            handleAddressChange("addressLine1", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Address Line 2
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="addressLine2"
                          value={address.addressLine2}
                          onChange={(e) =>
                            handleAddressChange("addressLine2", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            City
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="city"
                          value={address.city}
                          onChange={(e) =>
                            handleAddressChange("city", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            State
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="state"
                          value={address.state}
                          onChange={(e) =>
                            handleAddressChange("state", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Postal Code
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="postalCode"
                          value={address.postalCode}
                          onChange={(e) =>
                            handleAddressChange("postalCode", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Country
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="country"
                          value={address.country}
                          onChange={(e) =>
                            handleAddressChange("country", e.target.value)
                          }
                          required
                          disabled={organizationStatus === "INACTIVE"}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    
                    <Button
                      type="submit"
                      variant="outline-dark"
                      disabled={organizationStatus === "INACTIVE"}
                      style={{
                        width: "120px",
                        backgroundColor: organizationStatus === "INACTIVE" ? "#e9ecef" : "#FFFEF0",
                        border: "1px solid #0976A1",
                        color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                        marginRight : "10px",
                        cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                      }}
                    >
                      {isEditing ? "Save" : "Add Address"}
                    </Button>
                    <Button
                    variant="outline-dark"
                    // size="sm"
                    onClick={resetForm}
                    disabled={organizationStatus === "INACTIVE"}
                    style={{
                      width: "120px",
                      backgroundColor: organizationStatus === "INACTIVE" ? "#e9ecef" : "#FFFEF0",
                      border: "1px solid #0976A1",
                      color: organizationStatus === "INACTIVE" ? "#6c757d" : "#017EF3",
                      cursor: organizationStatus === "INACTIVE" ? "not-allowed" : "pointer",
                    }}
                  >
                    Cancel
                  </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default OrganizationAddress;
